export class Logger {
  scope?: string;

  constructor(scope?: string) {
    this.scope = scope;
  }

  trace = (msg: string, ...data: any[]): void => {
    console.trace(this.buildMsg(msg), ...data);
  };

  debug = (msg: string, ...data: any[]): void => {
    console.debug(this.buildMsg(msg), ...data);
  };

  info = (msg: string, ...data: any[]): void => {
    console.info(this.buildMsg(msg), ...data);
  };

  warn = (msg: string, ...data: any[]): void => {
    console.warn(this.buildMsg(msg), ...data);
  };

  error = (msg: string, ...data: any[]): void => {
    console.error(this.buildMsg(msg), ...data);
  };

  private buildMsg = (msg) => (this.scope ? `[${this.scope}] ${msg}` : msg);
}

export default new Logger();
